//设备生产者
import jmPcoductionHome from '@/components/jm/pcoduction/home.vue'
//设备类型
import jmPcoductionMacTypeHome from '@/components/jm/pcoduction/macType/home.vue'
import jmPcoductionMacTypeAdd from '@/components/jm/pcoduction/macType/add.vue'
import jmPcoductionMacTypeList from '@/components/jm/pcoduction/macType/list.vue'
import jmPcoductionMacTypeUpdate from '@/components/jm/pcoduction/macType/update.vue'

//设备详情
import jmPcoductionMacachineHome from '@/components/jm/pcoduction/machine/home.vue'
import jmPcoductionMacAdd from '@/components/jm/pcoduction/machine/add.vue'
import jmPcoductionMacList from '@/components/jm/pcoduction/machine/list.vue'
import jmPcoductionMacUpdate from '@/components/jm/pcoduction/machine/update.vue'
//货道详情
import jmPcoductionAisleHome from '@/components/jm/pcoduction/aisle/home.vue'
import jmPcoductionAisleAdd from '@/components/jm/pcoduction/aisle/add.vue'
import jmPcoductionAisleList from '@/components/jm/pcoduction/aisle/list.vue'
import jmPcoductionAisleUpdate from '@/components/jm/pcoduction/aisle/update.vue'
//故障类型
import jmPcoductionFaultTypeHome from '@/components/jm/pcoduction/macFaultType/home.vue'
import jmPcoductionFaultTypeAdd from '@/components/jm/pcoduction/macFaultType/add.vue'
import jmPcoductionFaultTypeList from '@/components/jm/pcoduction/macFaultType/list.vue'
import jmPcoductionFaultTypeUpdate from '@/components/jm/pcoduction/macFaultType/update.vue'

export default [{ //设备类型管理
		path: 'pcoduction',
		name: 'pcoduction',
		component: jmPcoductionHome,
		children: [{ //设备类型
			path: 'mactype',
			name: 'mactype',
			component: jmPcoductionMacTypeHome,
			children: [{
				path: 'list',
				name: 'jm/mac/mactype/list',
				component: jmPcoductionMacTypeList
			}, {
				path: 'add',
				name: 'jm/mac/mactype/add',
				component: jmPcoductionMacTypeAdd
			}, {
				path: 'update',
				name: 'jm/mac/mactype/update',
				component: jmPcoductionMacTypeUpdate
			}]
		},{ //设备信息
			path: 'machine',
			name: 'machine',
			component: jmPcoductionMacachineHome,
			children: [{
				path: 'list',
				name: 'jm/mac/machine/list',
				component: jmPcoductionMacList
			}, {
				path: 'add',
				name: 'jm/mac/machine/add',
				component: jmPcoductionMacAdd
			}, {
				path: 'update',
				name: 'jm/mac/machine/update',
				component: jmPcoductionMacUpdate
			}]
		},{ //故障信息
			path: 'faultType',
			name: 'faultType',
			component: jmPcoductionFaultTypeHome,
			children: [{
				path: 'list',
				name: 'jm/mac/faultType/list',
				component: jmPcoductionFaultTypeList
			}, {
				path: 'add',
				name: 'jm/mac/faultType/add',
				component: jmPcoductionFaultTypeAdd
			}, {
				path: 'update',
				name: 'jm/mac/faultType/update',
				component: jmPcoductionFaultTypeUpdate
			}]
		},{ //货道信息
			path: 'aisle',
			name: 'aisle',
			component: jmPcoductionAisleHome,
			children: [{
				path: 'list',
				name: 'jm/mac/aisle/list',
				component: jmPcoductionAisleList
			}, {
				path: 'add',
				name: 'jm/mac/aisle/add',
				component: jmPcoductionAisleAdd
			}, {
				path: 'update',
				name: 'jm/mac/aisle/update',
				component: jmPcoductionAisleUpdate
			}]
		}]
	}
]



// WEBPACK FOOTER //
// ./src/router/jm/pocduction/pocduction.js